import { Divider } from "../../../../../../../components/ui/Divider/Divider";

import { ChipStyled, GridItem } from "./DesktopTableRow.styled";

export const DesktopTableRow = ({ ip, provider, statusLabel, status }) => {
  return (
    <>
      <GridItem size={{ md: 4 }}>{ip}</GridItem>
      <GridItem size={{ md: 4 }}>{provider}</GridItem>
      <GridItem size={{ md: 4 }}>
        <ChipStyled label={statusLabel} color={status ? "error" : "primary"} />
      </GridItem>
      <Divider />
    </>
  );
};
